import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'not_applicable_see_country_specific_question_s_below_1'

export const dataPointDefinition = {
  retracedId: 'not_applicable_see_country_specific_question_s_below_1',
  name: 'Not applicable - see country specific question(s) below',
  description:
    "This option only appears for select countries and applies, e.g., when it is not possible to separate workers' and facility contributions. ",
  meta: {
    slcpMeta: {
      key: 'wb-wage-107x',
      number: 'WB-WAGE-123-9',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'wb-wage-66',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[1],fp-bi-7,Indonesia;Vietnam',
      machineShowHide: '[1],fp-bi-7,81;198',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-wage-107x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 35970,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
